export default function Page404() {

    return (
        <div>404 - Page Not Found.</div>
    )
}